import { MessageBox } from 'element-ui'
import { isEmptyObj } from 'sk-web-framework/utils'

import { saveSystemSpecEditState } from '@/api/setting'
import lang from '@/lang'
import store from '@/store'
export default {
  OkActionCb({ commit }, params) {
    if (params?.response?.data?.status == 'SUCCESS') {
      if (params?.requestDatas?.maintenanceState === true) {
        this.dispatch('OpenNotification', { message: '维护模式功能开启成功', type: 'success' })
      }
      if (params?.requestDatas?.maintenanceState === false) {
        this.dispatch('OpenNotification', { message: '维护模式功能关闭成功', type: 'success' })
      }
    }
  },
  OkAction({ commit }, params) {
    MessageBox.prompt('请输入维护开关操作码', lang.t('sk.tip'), {
      confirmButtonText: lang.t('confirm'),
      cancelButtonText: lang.t('cancel'),
      inputType: 'text',
      inputValidator(value) {
        if (isEmptyObj(value)) {
          return lang.t('login.needPassword')
        } else if (typeof value === 'string' && value.trim() === '') {
          return lang.t('sk.form.common_empty_string_valid')
        }
        return true
      },
      showClose: false,
      async: true
    }).then(({ value }) => {
      const formData = params.formController.getFormData()
      const state = {
        maintenanceState: formData.maintenanceState,
        maintenanceTime: formData.maintenanceTime,
        maintenanceCode: value
      }
      return saveSystemSpecEditState(state).then(function(response) {
        if (response?.data?.status == 'SUCCESS') {
          if (formData.maintenanceState === true) {
            store.dispatch('OpenNotification', { message: '维护模式功能开启成功', type: 'success' })
          }
          if (formData.maintenanceState === false) {
            store.dispatch('OpenNotification', { message: '维护模式功能关闭成功', type: 'success' })
          }
        }
        return true
      })
    })
  }
}
